import React, { useContext, useState, Fragment } from 'react';
import { Pressable, Text, View, Dimensions } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
const dimensions = Dimensions.get('window');
const smallScreen = dimensions.width < 800;

import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import { BlogProvider } from '../../contexts/BlogContext';
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  LinkContainer,
  LinkSpace,
  Button,
} from 'app/src/elements';
import Modal from 'app/src/elements/Modal';

import {
  BLOGS_WITH_COUNT
} from './queries';
import SubNav from './SubNav';
import NewBlog from './new';
import Card from './Card';
import Tags from './ManageTags';
import ManageFeaturedLabel from './ManageFeaturedLabel';
import moment from 'moment';

import {
  MainBlogContainer,
  CardContainer,
  SideBar
} from './elements';
import { useNavigate } from 'react-router-dom';

const inputStyle = {
  marginBottom: '10px'
}

const date = value => {
  if (!value) { return ''; }

  return moment(value).format('M/D/YY');
};

const baseColumns = [
  {
    key: 'title',
    label: 'Title',
    entry: ({ entry }) => entry.Title,
    sort: 'asc',
  },
  {
    key: 'date',
    label: 'Date',
    sort: 'prevent',
    width: 90,
    content: ({ entry }) => date(entry.createdAt),
  },
];

const Blogs = ({  }) => {
  const [refetch, setRefetch] = useState();
  const [showAddModal, setShowAddModal] = useState();
  const [showManageTagsModal, setShowManageTagsModal] = useState();
  const [showFeaturedBlogLabelModal, setShowFeaturedBlogLabelModal] = useState();
  const [selectedBlog, setSelectedBlog] = useState();
  const [data, setData] = useState([]);
  const { hasPolicy } = useContext(AuthContext);
  const navigate = useNavigate();

  // const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: ['ordered'],
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    ...baseColumns,
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => (
        <LinkContainer>
          <Pressable onPress={() => setSelectedBlog(entry)}>
            <Text>View</Text>
          </Pressable>
          <LinkSpace />
          {/* {role === 'Admin' && (
            <Pressable onPress={() => onHide(entry)} >
              <Text>{entry.hiddenAt ? 'UnHide' : 'Hide'}</Text>
            </Pressable>
          )} */}
        </LinkContainer>
      )
    },
  ];

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <SubNav refetch={refetch}>
        <View style={{display: 'flex', flexDirection: 'row', marginTop: '-10px'}}>
          <>
            {hasPolicy({type: 'Blog', action: 'create'}) ?
              <Pressable
                onPress={() => setShowAddModal(true)}
              >
                <Text style={{marginTop: '10px'}}>
                  +Add Blog
                </Text>
              </Pressable> :
              null
            }
            {hasPolicy({type: 'Blog', action: 'edit'}) ?
              <>
                <Pressable
                  onPress={() => setShowManageTagsModal(true)}
                  style={{marginLeft: '20px'}}
                >
                  <Text style={{marginTop: '10px'}}>
                    Manage Blog Categories
                  </Text>
                </Pressable>
                <Pressable
                  onPress={() => setShowFeaturedBlogLabelModal(true)}
                  style={{marginLeft: '20px'}}
                >
                  <Text style={{marginTop: '10px'}}>
                    Set Featured Blog Label
                  </Text>
                </Pressable>
              </> :
              null
            }
          </>
        </View>
      </SubNav>
      <ContentContainer>
        <PageTitle>Blog</PageTitle>
        <MainBlogContainer
          flexDirection={smallScreen ? 'column' : 'row'}
          style={{flexWrap: 'wrap'}}
        >
          <SideBar
            width={smallScreen ? '100%' : '45%'}
            maxWidth={smallScreen ? '100%' : '45%'}
            fromShow={true}
          >
            <DataTable.Gql
              setRefetch={setRefetch}
              query={BLOGS_WITH_COUNT}
              queryName='blogsWithCount'
              queryVariables={queryVariables}
              columns={columns}
              pageLength={20}
              // buttons={buttons}
              lengthMenu={ [10, 25, 50, 'All'] }
              setSettings={setSettings}
              dataUpdated={data => {
                setData(data);
                if(!selectedBlog || selectedBlog !== data.blogsWithCount.entries[0]) {
                  setSelectedBlog(data.blogsWithCount.entries[0]);
                }
              }}
              htmlTable
            />
          </SideBar>
          <View
            style={{
              // flexDirection: smallScreen ? 'column' : 'row',
              width: smallScreen ? '100%' : '45%',
              maxWidth: smallScreen ? '100%' : '45%',
              flexWrap: 'wrap'
            }}
          >
            {selectedBlog && (
              <CardContainer
                key={`card-container-${selectedBlog.id}`}
                width='100%'
                maxWidth='100%'
              >
                <Card key={`card-${selectedBlog.id}`} blog={selectedBlog} refetch={refetch} />
              </CardContainer>
            )}
          </View>
        </MainBlogContainer>
      </ContentContainer>

      {showAddModal &&
        <Modal
          showModal
          setShowModal={setShowAddModal}
          modalType="Add Blog"
        >
          <NewBlog
            setShowModal={setShowAddModal}
            refetch={refetch}
          />
        </Modal>
      }

      {showManageTagsModal &&
        <Modal
          showModal
          setShowModal={setShowManageTagsModal}
          modalType="Manage Blog Categoriess"
        >
          <Tags
            setShowModal={setShowManageTagsModal}
          />
        </Modal>
      }

      {showFeaturedBlogLabelModal &&
        <Modal
          showModal
          setShowModal={setShowFeaturedBlogLabelModal}
          modalType="Manage Featured Blog Label"
        >
          <ManageFeaturedLabel
            setShowModal={setShowFeaturedBlogLabelModal}
          />
        </Modal>
      }
    </MainContainer>
  );
};

export default Blogs;
